export const PlatformType = 'WEB';

export enum AuthEndpoints {
  LOGIN = '/login',
  LOGOUT = '/logout',
}
export enum AgentEndpoints {
  AGENTS = '/api/external/agents/v1',
  AGENTS_NEW = '/api/external/agents/v2',
  AGENTS_MVP = '/api/external/v2/agents',
  AGENT_SALE = '/api/external/agent-sale/v1',
  AGENT_ACTS = '/api/external/agent-acts/v1',
  AGENT_CONSENT = '/api/external/consent/v1/agent',
  AGENT_SRG = '/api/external/agents-srg/v1',
  AGENT_STANDARDS = '/api/external/standard/v1',
  REFERENCE_INFORMATION = '/api/external/reference-information/v1',
  NOTIFICATIONS = '/api/external/notifications/v1',
  PRINTED_CONTRACTS = '/api/external/contracts/v1/printed-form',
  AGENT_CONTRACTS = '/api/external/agents/v1/contracts',
  //TODO: rename and remove old when BE refactoring is done
  NEW_AGENT_CONTRACTS = '/api/external/v1/agents/contracts',
  NEW_AGENTS = '/api/external/v1/agents',
}

export enum CandidateEndpoints {
  CANDIDATES = '/api/external/candidates/v1',
  CANDIDATES_V1 = '/api/external/v1/candidates',
}

export enum DictionariesEndpoints {
  DICTIONARIES = '/api/common/v1/dictionaries',
}

export enum RequestMethods {
  POST = 'post',
  GET = 'get',
  PATCH = 'patch',
  PUT = 'put',
  DELETE = 'delete',
}
